import React from 'react';
import {ApontarHorasDireta} from "./ApontarHorasDireta";
import {ExportarHorasDiretaMes} from "./ExportarHorasDiretaMes";

const SCHEMA_NAME = 'cflow_work_times';

export const CflowHorasListCustomSchema = (name, schema) => {
    console.log('Customizando user list schema', name, schema)
    if (!(name === SCHEMA_NAME)) {
        return;
    }

    console.log('pageSchema.aaaaaaaaaaaaaa', schema)

    schema.header.customButtons = <>

        <ApontarHorasDireta/>
        <ExportarHorasDiretaMes />
    </>

    return schema;

}



